import { useState, type FormEvent } from 'react';
import { Plus, Trash2 } from 'lucide-react';
import { AsyncView, Button, Card, Input, Select, Table, Textarea, useToast } from '../ui';
import { api, ApiError } from '../lib/api';
import { useResource } from '../lib/useResource';

interface Contato { id:string; profileName:string|null; waId:string }
interface Memoria { key:string; content:string; expiresAt:string|null }

export function AgentContactMemories({enabled}:{enabled:boolean}) {
  const toast=useToast();
  const contatos=useResource<Contato[]>('/workspace/contacts',{enabled});
  const [contactId,setContactId]=useState('');
  const memorias=useResource<Memoria[]>(contactId?`/ai-agents/memories/contacts/${contactId}`:'',{enabled:enabled&&Boolean(contactId)});
  const [salvando,setSalvando]=useState(false);

  async function salvar(event:FormEvent<HTMLFormElement>){
    event.preventDefault(); if(!contactId)return;
    const dados=new FormData(event.currentTarget); setSalvando(true);
    try{
      await api(`/ai-agents/memories/contacts/${contactId}`,{method:'PUT',body:{key:String(dados.get('key')??''),content:String(dados.get('content')??''),expiresAt:null}});
      event.currentTarget.reset(); memorias.recarregar(); toast('Memória do contato salva.');
    }catch(error){toast(error instanceof ApiError?error.message:'Falha ao salvar.','danger');}finally{setSalvando(false);}
  }

  async function excluir(key:string){
    try{await api(`/ai-agents/memories/contacts/${contactId}/${encodeURIComponent(key)}`,{method:'DELETE'});memorias.recarregar();toast('Memória removida.');}
    catch(error){toast(error instanceof ApiError?error.message:'Falha ao remover.','danger');}
  }

  return <Card title="Memória por contato" subtitle="Preferências e contexto persistentes, isolados por pessoa e por workspace." as="h2">
    <AsyncView state={contatos.state} label="os contatos" skeletonRows={2} empty={{title:'Nenhum contato disponível',text:'As memórias individuais podem ser registradas depois que o contato entrar no workspace.'}}>
      {(linhas)=><div className="agentes__memoria-contato">
        <Select label="Contato" value={contactId} onChange={(e)=>setContactId(e.currentTarget.value)} options={[{value:'',label:'Selecione um contato'},...linhas.map((c)=>({value:c.id,label:`${c.profileName??'Sem nome'} · ${c.waId}`}))]}/>
        {contactId&&<>
          <form className="agentes__memoria-form" onSubmit={salvar}>
            <Input label="Chave" name="key" required placeholder="preferencia_contato" pattern="[a-z0-9._-]+"/>
            <Textarea label="Conteúdo" name="content" required rows={2}/>
            <Button variant="primary" type="submit" loading={salvando} icon={<Plus size={18} aria-hidden="true"/>}>Salvar memória</Button>
          </form>
          <AsyncView state={memorias.state} label="as memórias deste contato" skeletonRows={2} empty={{title:'Sem memórias para este contato',text:'Registre apenas fatos úteis para atendimentos futuros.'}}>
            {(items) => (
              <Table caption="Memórias do contato selecionado" rows={items} rowKey={(item)=>item.key} columns={[
              {key:'key',header:'Chave',cell:(item)=><code>{item.key}</code>},{key:'content',header:'Conteúdo',cell:(item)=>item.content},
              {key:'actions',header:'Ações',align:'end',cell:(item)=><Button variant="tertiary" size="sm" icon={<Trash2 size={16} aria-hidden="true"/>} onClick={()=>void excluir(item.key)}>Remover</Button>},
              ]}/>
            )}
          </AsyncView>
        </>}
      </div>}
    </AsyncView>
  </Card>;
}
